import styled from 'styled-components'

import theme from 'config/theme'

const Label = styled.span`
  color: ${theme.colors.light.fg};
  font-size: ${theme.fonts.sizes.xs};
  font-weight: bold;
  position: relative;
  text-transform: uppercase;
`

export default Label
